import React, {useEffect, useState} from 'react';

import EmergencyContact from './EmergencyContact';

import { Row, Col, Button, Form } from "react-bootstrap";
import {formatedRun} from '../../utils/RunUtil';

const FormProfile = ({user, afp, isapre, region, isRoleUser, sendEvent, eventParent}) => {

    if(isRoleUser === undefined || isRoleUser === null || isRoleUser === ''){ isRoleUser = true; }

    const defaultData = {
        img: null,
        username: null,
        email: null,
        run: null,
        firstName: null,
        secondName: null,
        lastName: null,
        surName: null,
        nationality: null,
        civilStatus: null,
        birthday: null,
        phone: null,
        cellphone: null,
        emergencyContacts: [],
        region: null,
        comuna: null,
        afp: null,
        isapre: null,
        direction: null,
        isMaintainer: false
      };

    const [data, setData] = useState(defaultData);

    useEffect(() => {        
        if(user && user.run){
            user.run = formatedRun(user.run)
            setData(user);
        }else{
            setData(defaultData);
        }
        // eslint-disable-next-line
    }, [user]);

    const onChangeInput = e => {
        if(e.target.name.includes('.')){
            setData({
                ...data,
                [e.target.name.split('.')[0]] : {
                   [e.target.name.split('.')[1]]: e.target.value
                }
            })
        }else {        
            setData({
                ...data,
                [e.target.name] : e.target.value
            })
        }
    }

    const onChangeRut = e => {
        let value = formatedRun(e.target.value);
  
        setData({
            ...data,
            [e.target.name] : value
        })
    }

    useEffect(() => {
         //para enviar data al padre
         if(!isRoleUser){ eventParent(data);}
         // eslint-disable-next-line
    }, [data])

    const onChangeInputList = (e) => {
        
        let list = data[e.target.name.split('.')[0]];
        if(list.length === 0){
            list.push({id: null, fullName: null, email: null, phone: null, cellphone: null})
            setData({
                ...data,
                [e.target.name.split('.')[0] ]: list
            })
        }
        list[e.target.name.split('.')[1]][e.target.name.split('.')[2]] = e.target.value ;
         setData({
            ...data,
            [e.target.name.split('.')[0] ]: list
        });   
    }

    const handleForm = (e) => {
        e.preventDefault();
        setData({
            ...data,
            run: data.run.replace(/\./g,'')
        })
        data.run = data.run.replace(/\./g,'')
       sendEvent(data)
    }

    const onClickRol = () => {
        setData({
            ...data,
            isMaintainer: !data.isMaintainer
        });
    }
    
    return ( 
        <Form onSubmit={handleForm}>
            {isRoleUser ? null :
                <Form.Group as={Row} controlId="formHorizontalEmail">
                    <Form.Label column sm={2}>
                        ROL
                    </Form.Label>
                    <Col sm={10}>
                        <Form.Check
                            name="isMaintainer"
                            type="switch"
                            checked={data.isMaintainer}                            
                            onClick={onClickRol}
                            id="custom-switch"
                            label="Habilitar como Mantenedor"
                            size="sm"
                        />
                    </Col>
                </Form.Group>
            }
            <Form.Group as={Row} controlId="formHorizontalEmail">
                <Form.Label column sm={2}>
                    RUN
                </Form.Label>
                <Col sm={10}>
                    <Form.Control 
                        type="text" 
                        name="run"
                        maxlength="12"
                        placeholder="11.1111.111-1" 
                        size="" 
                        disabled={isRoleUser} 
                        value={data.run}
                        onChange={onChangeRut} 
                        required={true}/>
                </Col>
            </Form.Group>

            <Form.Group as={Row} controlId="formHorizontalEmail">
                <Form.Label column sm={2}>
                    Primer Nombre
                </Form.Label>
                <Col sm={4}>
                    <Form.Control 
                        type="text" 
                        name="firstName"
                        placeholder="Nombre" 
                        size="" 
                        disabled={isRoleUser} 
                        value={data.firstName}
                        onChange={onChangeInput}
                        required={true}/>
                </Col>

                <Form.Label column sm={2}>
                    Segundo Nombre
                </Form.Label>
                <Col sm={4}>
                    <Form.Control 
                        type="text" 
                        name="secondName"
                        placeholder="Nombre" 
                        size="" 
                        disabled={isRoleUser} 
                        value={data.secondName}
                        onChange={onChangeInput}
                        required={true}/>
                </Col>
            </Form.Group>

            <Form.Group as={Row} controlId="formHorizontalEmail">
                <Form.Label column sm={2}>
                    Apellido Paterno
                </Form.Label>
                <Col sm={4}>
                    <Form.Control 
                        type="text" 
                        name="lastName"
                        placeholder="Nombre" 
                        size="" 
                        disabled={isRoleUser} 
                        value={data.lastName}
                        onChange={onChangeInput}
                        required={true}/>
                </Col>

                <Form.Label column sm={2}>
                    Apellido Materno
                </Form.Label>
                <Col sm={4}>
                    <Form.Control 
                        type="text" 
                        name="surName"
                        placeholder="Nombre" 
                        size="" 
                        disabled={isRoleUser} 
                        value={data.surName}
                        onChange={onChangeInput}
                        required={true}/>
                </Col>
            </Form.Group>

            <Form.Group as={Row} controlId="formHorizontalPassword">
                <Form.Label column sm={2}>
                Nacionalidad
                </Form.Label>
                <Col sm={4}>
                <Form.Control 
                    type="text" 
                    name="nationality"
                    placeholder="Chilena" 
                    disabled={isRoleUser} 
                    value={data.nationality}
                    onChange={onChangeInput}
                    required={true}/>
                </Col>

                <Form.Label column sm={2}>
                    Estado Civil
                </Form.Label>
                <Col sm={4}>
                <Form.Control 
                    type="text" 
                    name="civilStatus"
                    placeholder="Soltero" 
                    disabled={isRoleUser} 
                    value={data.civilStatus}
                    onChange={onChangeInput}
                    required={true}/>
                </Col>
            </Form.Group>

            <Form.Group as={Row} controlId="formHorizontalPassword">
                <Form.Label column sm={2}>
                    Fecha de Nacimiento
                </Form.Label>
                <Col sm={10}>
                <Form.Control 
                    type="date" 
                    name="birthday"
                    placeholder="12-12-12" 
                    disabled={isRoleUser} 
                    value={data.birthday}
                    onChange={onChangeInput}
                    required={true}/>
                </Col>
            </Form.Group>

            <Form.Group as={Row} controlId="formHorizontalPassword">
                <Form.Label column sm={2}>
                    Email
                </Form.Label>
                <Col sm={10}>
                <Form.Control 
                    type="email" 
                    name="email"
                    placeholder="Email" 
                    disabled={isRoleUser} 
                    value={data.email}
                    onChange={onChangeInput}
                    required={true}/>
                </Col>
            </Form.Group>

            <Form.Group as={Row} controlId="formHorizontalPassword">
                <Form.Label column sm={2}>
                    Región
                </Form.Label>
                <Col sm={4}>
                    <Form.Control as="select" custom name="region" onChange={onChangeInput} required={true}>
                        {region.map(region => (
                            <option 
                                value={region.name} 
                                selected={data.region === region.name}
                                >
                                    {region.name}
                                </option>
                        ))}
                    </Form.Control>
                </Col>
                

                <Form.Label column sm={2}>
                    Comuna
                </Form.Label>
                <Col sm={4}>
                    <Form.Control as="select" custom name="comuna" onChange={onChangeInput} required={true}>
                        {region.map(reg => {
                            if(data.region === reg.name){
                                return reg.communes.map(commune => (
                                    <option 
                                        value={commune.name} 
                                        selected={data.comuna === commune.name}
                                        >
                                            {commune.name}
                                    </option>
                                ))}else {return null}
                        })}
                    </Form.Control>  
                </Col>                             
            </Form.Group>

            <Form.Group as={Row} controlId="formHorizontalPassword">
                <Form.Label column sm={2}>
                    Dirección
                </Form.Label>
                <Col sm={10}>
                <Form.Control 
                    type="text" 
                    name="direction"
                    placeholder="Dirección" 
                    value={data.direction}
                    onChange={onChangeInput}
                    required={true}/>
                </Col>
            </Form.Group>

            <Form.Group as={Row} controlId="formHorizontalPassword">
                <Form.Label column sm={2}>
                    Teléfono Fijo
                </Form.Label>
                <Col sm={4}>
                <Form.Control 
                    type="text" 
                    name="phone" 
                    placeholder="Teléfono Fijo" 
                    value={data.phone} 
                    onChange={onChangeInput}
                    required={false}/>
                </Col>

                <Form.Label column sm={2}>
                    Teléfono Celular
                </Form.Label>
                <Col sm={4}>
                <Form.Control 
                    type="text" 
                    name="cellphone"
                    placeholder="Teléfono Celular" 
                    value={data.cellphone}
                    onChange={onChangeInput}
                    required={false}/>
                </Col>
            </Form.Group>

            <Form.Group as={Row} controlId="formHorizontalPassword">
                <Form.Label column sm={2}>
                    AFP
                </Form.Label>
                <Col sm={4}>  
                    <Form.Control as="select" custom name="afp" onChange={onChangeInput} required={true}>
                        <option selected="selected" value="">Seleccionar...</option>
                        {afp.map(afp => (
                            <option 
                                value={afp.name} 
                                selected={data.afp === afp.name}
                                >
                                    {afp.name}
                                </option>
                        ))}
                    </Form.Control>
                </Col>

                <Form.Label column sm={2}>
                    Isapre
                </Form.Label>
                <Col sm={4}>
                <Form.Control as="select" custom name="isapre" onChange={onChangeInput} required={true}>
                    <option selected="selected" value="">Seleccionar...</option>
                        {isapre.map(isapre => (
                            <option 
                                value={isapre.name} 
                                selected={data.isapre === isapre.name}
                                >
                                    {isapre.name}
                                </option>
                        ))}
                    </Form.Control>
                </Col>
            </Form.Group>
            <hr />
            <h5>Contacto de Emergencia</h5>  
            <hr />         
            {data.emergencyContacts != null && data.emergencyContacts.length > 0 ? data.emergencyContacts.map( (contact, index) => (
                <>                   
                    <EmergencyContact key={index} index={index} contact={contact} onChangeInput={onChangeInputList}/>
                </>
            ))
            :  <EmergencyContact index={0} contact={ {id: null, fullName: null, email: null, phone: null, cellphone: null}} onChangeInput={onChangeInputList}/>
        }        
            
            {isRoleUser ? 
                <Form.Group as={Row}>
                    <Col sm={{ span: 10, offset: 2 }}>
                        <Button type="submit" block>Actualizar</Button>
                    </Col>
                </Form.Group> :
                null }
        </Form>
     );
}
 
export default FormProfile;